import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    datasources: {
        modality: {
            visio: "Visio-conférence",
            local: "Présentiel"
        },
        advertisement: {
            none: "Aucun",
            timeslot: "Plage horaire uniquement"
        }
    }
};

export type _I18nBooking = typeof _fr;

const _en: _I18nBooking = {
    datasources: {
        modality: {
            visio: "Visio",
            local: "Local"
        },
        advertisement: {
            none: "None",
            timeslot: "Busy hours only"
        }
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nBooking(lang?: string): _I18nBooking {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}